/* eslint-disable prettier/prettier */
export default {
    getDomain() {
        return "https://newbuddha.org:3215";
    },
    makeThunnail( image ) {
        let tcanvas = document.createElement("canvas"),
            max_size = 400,
            // 최대 기준을 1280으로 잡음.
            width = image.width,
            height = image.height;
        if (width > height) {
          // 가로가 길 경우
          if (width > max_size) {
            height *= max_size / width;
            width = max_size;
          }
        } else {
          // 세로가 길 경우
          if (height > max_size) {
            width *= max_size / height;
            height = max_size;
          }
        }
        tcanvas.width = width;
        tcanvas.height = height;
        tcanvas.getContext("2d").drawImage(image, 0, 0, width, height);
        return tcanvas.toDataURL("image/png");
      },
}